import React from "react";
import { Link } from "react-router-dom";
import { CalendarDays, ArrowRight } from "lucide-react";
import { fetchNews } from "../lib/api";
import { useCachedData } from "../lib/useCachedData";

const THUMBS = [
  "https://images.unsplash.com/photo-1485802240079-a8245c843b95?crop=entropy&cs=srgb&fm=jpg&w=400&q=70",
  "https://images.unsplash.com/photo-1590585382453-8b749e9d5224?crop=entropy&cs=srgb&fm=jpg&w=400&q=70",
  "https://images.unsplash.com/photo-1641531105535-1ead3c1784ab?crop=entropy&cs=srgb&fm=jpg&w=400&q=70",
  "https://images.unsplash.com/photo-1510925758641-869d353cecc7?crop=entropy&cs=srgb&fm=jpg&w=400&q=70",
];

function formatLong(iso) {
  try {
    return new Date(iso).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

export function NewsAndUpdatesGrid({ limit = 4 }) {
  const { data } = useCachedData("mst:news", fetchNews);
  const items = (data?.items || []).slice(0, limit);

  return (
    <section data-testid="news-updates-grid">
      <div className="flex items-center justify-between mb-5">
        <h2 className="font-head font-extrabold text-2xl sm:text-3xl text-slate-900">
          Latest Updates & News
        </h2>
        <Link
          to="/blog/"
          data-testid="news-view-all"
          className="text-[#ff4500] font-semibold text-sm flex items-center gap-1 hover:gap-2 transition-all"
        >
          View All <ArrowRight size={15} />
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {items.map((n, i) => (
          <article
            key={n.id}
            data-testid={`news-card-${i}`}
            className="bg-white rounded-xl border border-slate-200 card-shadow overflow-hidden flex flex-col"
          >
            <div className="aspect-[16/10] overflow-hidden bg-slate-100">
              <img
                src={THUMBS[i % THUMBS.length]}
                alt={n.title}
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-4 flex flex-col flex-1">
              <span className="flex items-center gap-1 text-xs text-[#ff4500] font-semibold mb-2">
                <CalendarDays size={13} /> {formatLong(n.date)}
              </span>
              <h3 className="font-head font-bold text-[15px] text-slate-900 leading-snug flex-1">
                {n.title}
              </h3>
              <Link
                to="/blog/"
                className="mt-3 text-[#ff4500] text-sm font-semibold flex items-center gap-1 hover:gap-2 transition-all"
              >
                Read More <ArrowRight size={14} />
              </Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
